import React, { useEffect } from "react";
import { 
  FiGlobe, FiTarget, FiLayers, FiShield, FiTrendingUp, 
  FiMessageSquare, FiSearch, FiBookOpen, FiZap, FiUser,
  FiAward, FiCpu, FiEye, FiCheckCircle, FiPlusCircle,
  FiLayout, FiActivity, FiMapPin, FiUsers, FiHexagon,
  FiTrello, FiCommand, FiUserCheck, FiFilter, FiDownload,
  FiMail, FiGitBranch
} from "react-icons/fi";
import "../styles/RevueRIGSIDA.css";
import revueHeroImg from '../assets/revue_hero.jpg';

export default function RevueRIGSIDA() {
  const [revueData, setRevueData] = React.useState(null);
  
  useEffect(() => {
    try {
      const saved = localStorage.getItem('iamar_revue_rigsida_content');
      if (saved) {
        setRevueData(JSON.parse(saved));
      }
    } catch (e) {
      console.error(e);
    }
  }, []);
  
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  const heroBg = revueData?.hero?.bgImage || revueHeroImg;
  const heroTitle = revueData?.hero?.title || "Revue RIGSIDA";
  const heroSubtitle = revueData?.hero?.subtitle || "Revue Internationale de Gouvernance Sécuritaire et Développement en Afrique";
  const resumeLead = revueData?.resume?.lead;
  const resumeDetails = revueData?.resume?.details;
  const directorPhoto = revueData?.director?.photoUrl || "https://via.placeholder.com/180?text=Dr.+Redouane";
  const directorName = revueData?.director?.name || "Dr. Redouane El Majdouli";
  const directorAffiliation = revueData?.director?.affiliation || "Université Ibn Zohr – Maroc";
  const directorFlag = revueData?.director?.countryFlag || "🇲🇦";

  return (
    <div className="revue-page-container">
      {/* HERO SECTION */}
      <section className="revue-hero-banner" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-content">
          <h1>{heroTitle}</h1>
          <p>{heroSubtitle}</p>
        </div>
      </section>

      <div className="revue-main-content-wrapper">
        
        {/* 1. RÉSUMÉ SCIENTIFIQUE */}
        <section className="revue-sub-section resume-section" id="resume">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>RÉSUMÉ SCIENTIFIQUE</h2>
          </div>

          <div className="revue-content-box">
            <div className="resume-text">
              <p className="lead-paragraph">
                {resumeLead || (
                  <>
                    La <strong>Revue Internationale de Gouvernance Sécuritaire et Développement en Afrique (RIGSIDA)</strong> est une revue scientifique à comité de lecture, dédiée à la publication de recherches interdisciplinaires dans les domaines de la gouvernance sécuritaire, de la transformation numérique, du développement durable et des politiques publiques.
                  </>
                )}
              </p>
              
              <p>
                {resumeDetails || "Elle vise à constituer un espace de dialogue scientifique entre chercheurs, experts et praticiens, en favorisant les approches comparatives et les analyses innovantes dans les contextes africains et euro-méditerranéens."}
              </p>
            </div>
          </div>
        </section>

        {/* 2. OBJECTIFS */}
        <section className="revue-sub-section objectives-section" id="objectifs">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>OBJECTIFS DE LA REVUE</h2>
          </div>

          <div className="objectives-grid">
            <div className="objective-card">
              <div className="objective-icon">
                <FiTrendingUp />
              </div>
              <h3>Promouvoir la recherche</h3>
              <p>Favoriser la recherche en gouvernance sécuritaire et transformation institutionnelle</p>
            </div>

            <div className="objective-card">
              <div className="objective-icon">
                <FiCpu />
              </div>
              <h3>Transformation numérique</h3>
              <p>Analyser les transformations numériques et leur impact sur les systèmes de sécurité</p>
            </div>

            <div className="objective-card">
              <div className="objective-icon">
                <FiLayers />
              </div>
              <h3>Interdisciplinarité</h3>
              <p>Encourager les approches pluridisciplinaires et les analyses croisées</p>
            </div>

            <div className="objective-card">
              <div className="objective-icon">
                <FiCommand />
              </div>
              <h3>Politiques publiques</h3>
              <p>Contribuer directement aux débats et décisions de politiques publiques</p>
            </div>

            <div className="objective-card">
              <div className="objective-icon">
                <FiGlobe />
              </div>
              <h3>Recherche africaine</h3>
              <p>Valoriser et promouvoir la recherche africaine sur la scène internationale</p>
            </div>

            <div className="objective-card">
              <div className="objective-icon">
                <FiMessageSquare />
              </div>
              <h3>Dialogue stratégique</h3>
              <p>Créer un espace de dialogue entre acteurs académiques et institutionnels</p>
            </div>
          </div>
        </section>

        {/* 3. COMITÉ ÉDITORIAL */}
        <section className="revue-sub-section editorial-section" id="comite-editorial">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>COMITÉ ÉDITORIAL</h2>
          </div>

          <div className="editorial-container">
            <div className="org-chart">
              <div className="org-director">
                <div className="editor-role-label">Directeur de la Revue</div>
                <div className="editor-card">
                  <div className="director-portrait-section">
                    <img src="https://via.placeholder.com/180?text=Dr.+Redouane" alt="Dr. Redouane El Majdouli" className="portrait-image" />
                    <div className="director-logo-badge">
                      <img src="https://via.placeholder.com/60?text=Ibn+Zohr" alt="Logo Ibn Zohr" className="logo-placeholder" />
                      <div className="country-flag">🇲🇦</div>
                    </div>
                  </div>
                  <h3>Dr. Redouane El Majdouli</h3>
                  <p className="editor-affiliation">Université Ibn Zohr – Maroc</p>
                </div>
              </div>
              
              <div className="org-connector"></div>
              
              <div className="org-members">
                <div className="member-card">
                  <img src="https://via.placeholder.com/140?text=Dr.+Sarah" alt="Dr. Sarah Johnson" className="member-portrait" />
                  <div className="member-header">
                    <img src="https://via.placeholder.com/50?text=Cambridge" alt="Cambridge Logo" className="member-logo" />
                    <div className="member-flag">🇬🇧</div>
                  </div>
                  <h4>Dr. </h4>
                  <p className="member-role">Éditrice adjointe</p>
                  <p className="member-affiliation">Université de Cambridge – UK</p>
                </div>
                
                <div className="member-card">
                  <img src="https://via.placeholder.com/140?text=Prof.+Ahmed" alt="Prof. Ahmed Benali" className="member-portrait" />
                  <div className="member-header">
                    <img src="https://via.placeholder.com/50?text=Tunis" alt="Tunis Logo" className="member-logo" />
                    <div className="member-flag">🇹🇳</div>
                  </div>
                  <h4>Prof. </h4>
                  <p className="member-role">Membre du comité</p>
                  <p className="member-affiliation">Université de Tunis – Tunisie</p>
                </div>
                
                <div className="member-card">
                  <img src="https://via.placeholder.com/140?text=Dr.+Maria" alt="Dr. Maria Santos" className="member-portrait" />
                  <div className="member-header">
                    <img src="https://via.placeholder.com/50?text=Lisbonne" alt="Lisbonne Logo" className="member-logo" />
                    <div className="member-flag">🇵🇹</div>
                  </div>
                  <h4>Dr. </h4>
                  <p className="member-role">Spécialiste en cybersécurité</p>
                  <p className="member-affiliation">Université de Lisbonne – Portugal</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. INSTRUCTIONS AUX AUTEURS */}
        <section className="revue-sub-section authors-section" id="instructions">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>INSTRUCTIONS AUX AUTEURS</h2>
          </div>

          <div className="authors-instructions">
            <div className="instruction-intro">
              <p>Les auteurs doivent soumettre des <strong>articles originaux non publiés</strong>, respectant les normes académiques internationales (format APA).</p>
            </div>

            <div className="requirements-grid">
              <div className="requirement-item">
                <div className="requirement-num">01</div>
                <div className="requirement-content">
                  <h4>Structure de l'article</h4>
                  <ul>
                    <li>Titre (descriptif et pertinent)</li>
                    <li>Résumé (150–250 mots)</li>
                    <li>Mots-clés (5 maximum)</li>
                  </ul>
                </div>
              </div>

              <div className="requirement-item">
                <div className="requirement-num">02</div>
                <div className="requirement-content">
                  <h4>Contenu obligatoire</h4>
                  <ul>
                    <li>Introduction et problématique</li>
                    <li>Méthodologie claire</li>
                    <li>Résultats et analyse</li>
                    <li>Discussion critique</li>
                  </ul>
                </div>
              </div>

              <div className="requirement-item">
                <div className="requirement-num">03</div>
                <div className="requirement-content">
                  <h4>Références</h4>
                  <ul>
                    <li>Normes APA (6ème édition)</li>
                    <li>Bibliographie complète</li>
                    <li>Citations intégrées</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="submission-cta">
              <button className="submit-btn">
                <FiMail size={18} />
                Soumettre un article
              </button>
            </div> */}
          </div>
        </section>

        {/* 5. POLITIQUE D'ÉVALUATION */}
        <section className="revue-sub-section evaluation-section" id="evaluation">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>POLITIQUE D'ÉVALUATION</h2>
          </div>

          <div className="evaluation-process">
            <div className="process-intro">
              <p>Tous les articles soumis à RIGSIDA suivent un processus rigoureux de <strong>double aveugle (double blind peer review)</strong>.</p>
            </div>

            <div className="process-steps">
              <div className="process-step">
                <div className="step-num">1</div>
                <h3>Vérification initiale</h3>
                <p>Évaluation de la conformité aux normes éditoriales</p>
              </div>

              <div className="process-step">
                <div className="step-num">2</div>
                <h3>Sélection des évaluateurs</h3>
                <p>Au minimum 2 évaluateurs indépendants et anonymes</p>
              </div>

              <div className="process-step">
                <div className="step-num">3</div>
                <h3>Évaluation en double aveugle</h3>
                <p>Ni l'auteur ni l'évaluateur ne se connaissent</p>
              </div>

              <div className="process-step">
                <div className="step-num">4</div>
                <h3>Décision éditoriale</h3>
                <p>Acceptation, révision mineure, révision majeure ou rejet</p>
              </div>
            </div>
          </div>
        </section>

        {/* 6. MODÈLE ÉCONOMIQUE */}
        <section className="revue-sub-section economic-section" id="modele">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>MODÈLE ÉCONOMIQUE</h2>
          </div>

          <div className="economic-model">
            <div className="model-card open-access">
              <div className="card-icon">
                <FiGlobe size={48} />
              </div>
              <h3>Accès Libre</h3>
              <p>La revue fonctionne en <strong>accès libre (Open Access)</strong></p>
            </div>

            <div className="model-card no-fees">
              <div className="card-icon">
                <FiCheckCircle size={48} />
              </div>
              <h3>Gratuit pour les auteurs</h3>
              <p>Aucun frais de soumission ni de publication n'est exigé des auteurs</p>
            </div>

            <div className="model-card open-distribution">
              <div className="card-icon">
                <FiDownload size={48} />
              </div>
              <h3>Distribution gratuite</h3>
              <p>Accès gratuit à tous les articles sur le portail IAMAR</p>
            </div>
          </div>
        </section>

        {/* 7. DROITS D'AUTEUR ET LICENCE */}
        <section className="revue-sub-section copyright-section" id="copyright">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>DROITS D'AUTEUR & LICENCE DE PUBLICATION</h2>
          </div>

          <div className="copyright-content">
            <div className="copyright-box">
              <h3>Droits d'auteur</h3>
              <p>
                Les auteurs <strong>conservent l'intégralité des droits d'auteur</strong> de leurs articles. 
                Ils accordent à la revue un droit non-exclusif de publication et de diffusion.
              </p>
            </div>

            <div className="license-box">
              <h3>Licence Creative Commons</h3>
              <div className="license-badge">CC BY 4.0</div>
              <p>
                Tous les articles sont publiés sous <strong>licence Creative Commons CC BY 4.0</strong>, 
                permettant le partage et l'adaptation avec attribution obligatoire de l'auteur.
              </p>
              <div className="license-permissions">
                <div className="permission"><FiCheckCircle /> Partage et distribution</div>
                <div className="permission"><FiCheckCircle /> Adaptation et transformation</div>
                <div className="permission"><FiCheckCircle /> Utilisation commerciale</div>
                <div className="permission"><FiCheckCircle /> Attribution obligatoire</div>
              </div>
            </div>
          </div>
        </section>

        {/* 8. POLITIQUE ANTI-PLAGIAT */}
        <section className="revue-sub-section plagiarism-section" id="anti-plagiat">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>POLITIQUE ANTI-PLAGIAT</h2>
          </div>

          <div className="plagiarism-policy">
            <div className="policy-intro">
              <p>
                RIGSIDA adopte une <strong>politique zéro tolérance</strong> envers le plagiat et les violations d'intégrité académique.
              </p>
            </div>

            <div className="plagiarism-measures">
              <div className="measure-card">
                <div className="measure-icon">
                  <FiSearch size={32} />
                </div>
                <h3>Vérification systématique</h3>
                <p>Tous les articles sont soumis à une <strong>vérification anti-plagiat</strong> via Turnitin ou outils équivalents</p>
              </div>

              <div className="measure-card">
                <div className="measure-icon">
                  <FiAlertCircle size={32} />
                </div>
                <h3>Seuil de similarité</h3>
                <p>Tout manuscrit présentant un taux de similarité élevé est <strong>automatiquement rejeté</strong></p>
              </div>

              <div className="measure-card">
                <div className="measure-icon">
                  <FiShield size={32} />
                </div>
                <h3>Intégrité académique</h3>
                <p>Respect strict des standards d'éthique académique internationale</p>
              </div>
            </div>
          </div>
        </section>

        {/* 9. DÉLAI DE PUBLICATION */}
        <section className="revue-sub-section timeline-section" id="timeline">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h2>DÉLAI DE PUBLICATION</h2>
          </div>

          <div className="timeline-info">
            <div className="timeline-box">
              <div className="timeline-number">4-8</div>
              <div className="timeline-text">
                <p className="timeline-label">Semaines</p>
                <p className="timeline-desc">Délai moyen entre la soumission et la publication</p>
              </div>
            </div>

            <div className="timeline-breakdown">
              <div className="breakdown-item">
                <span className="breakdown-label">Examen initial</span>
                <span className="breakdown-time">1-2 semaines</span>
              </div>
              <div className="breakdown-item">
                <span className="breakdown-label">Évaluation par les pairs</span>
                <span className="breakdown-time">2-4 semaines</span>
              </div>
              <div className="breakdown-item">
                <span className="breakdown-label">Révisions et décision</span>
                <span className="breakdown-time">1-2 semaines</span>
              </div>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="revue-cta-section">
          <div className="cta-content">
            <h2>Prêt à soumettre votre recherche ?</h2>
            <p>Rejoignez la communauté scientifique de RIGSIDA et publiez votre travail en accès libre</p>
            <button className="cta-btn">Soumettre un article</button>
          </div>
        </section>

      </div>
    </div>
  );
}

// Placeholder for FiAlertCircle if not imported
const FiAlertCircle = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

const FiPlus = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);
